import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Scroll from "./Components/Scroll";
import SingleProduct from "./Components/SingleProduct";
import DemoModal from "./Components/DemoModal";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Product from "./Pages/Product";
import Service from "./Pages/Service";


const App = () => {
  const location = useLocation();
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [demoProduct, setDemoProduct] = useState("");

  const openDemoModal = (productName = "") => {
    // handle event objects or product names
    if (typeof productName === 'string') {
      setDemoProduct(productName);
    } else {
      setDemoProduct("");
    }
    setIsDemoModalOpen(true);
  };
  const closeDemoModal = () => setIsDemoModalOpen(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    AOS.refresh();
  }, [location.pathname]);

  useEffect(() => {
   AOS.init({  });
  }, []);

  return (
    <>
      <Navbar openDemo={openDemoModal} />
      <Routes>
        <Route path="/" element={<Home openDemo={openDemoModal} />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/product" element={<Product openDemo={openDemoModal} />} />
        <Route path="/product/:id" element={<SingleProduct openDemo={openDemoModal} />} />
      </Routes>
      <Footer openDemo={openDemoModal} />
      <Scroll />
      <DemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} preselectedProduct={demoProduct} />
    </>
  );
};

export default App;
